import { Injectable } from '@angular/core';
import { IconUtilityService } from 'src/app/shared/service/icon-utility-service/icon-utility.service';

@Injectable({
  providedIn: 'root'
})
export class SalesChooseMapService {

  constructor(private iconUtility: IconUtilityService) { }

  salesChooseMap(rawValues: Array<any>) {
    return rawValues
      ? rawValues.map((customerChoosen) => ({
          ...customerChoosen,
          choose: this.getIconChange(customerChoosen),
        }))
      : [];
  }

  getIconChange(customerChoosen) {
    return [
      {
        customerChoosen: customerChoosen,
        icon: this.iconUtility.getMatArrowIcon(),
      },
    ];
  }
}
